import PropTypes from 'prop-types';
import Head from 'next/head';
import { css } from 'linaria';
import { GlobalFooter } from 'components/global-footer/global-footer';
import { PageContainer } from 'components/page-container/page-container';
import { breakpointLargeTablet } from 'common/constants';
import GlobalNav from 'connectors/global-nav/global-nav';
import { PocketHead } from 'containers/_layouts/_head';
const myListContainer = "m1jnn1pl";
const fixedNavContainer = "fzr3ha2";

function mainLayout({
  metaData,
  children,
  title = 'Pocket',
  canonical,
  subset,
  tag,
  selectedNavLink,
  isFullWidthLayout
}) {
  return <>
      <PocketHead title={title} canonical={canonical} metaData={metaData} />
      <GlobalNav selectedLink={selectedNavLink} subset={subset} tag={tag} />
      <div className={fixedNavContainer}>
        {isFullWidthLayout ? children : <PageContainer>
            <div className={myListContainer}>{children}</div>
          </PageContainer>}
      </div>
      <GlobalFooter />
    </>;
}

mainLayout.propTypes = {
  /**
   * Set to true if you need to have full-width or custom width content, in which
   * case you intend to implement your own content container in between the
   * GlobalNav and GlobalFooter, or use <PageContainer> manually within your
   * page content.
   */
  isFullWidthLayout: PropTypes.bool
};
mainLayout.defaultProps = {
  selectedNavLink: undefined,
  isFullWidthLayout: false
};
export default mainLayout;

require("./with-sidebar.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./with-sidebar.js");